import { render, staticRenderFns } from "./BlocklistModal.vue?vue&type=template&id=77f22f46&scoped=true&"
import script from "./BlocklistModal.vue?vue&type=script&lang=ts&"
export * from "./BlocklistModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f22f46",
  null
  
)

export default component.exports